// removed by extract-text-webpack-plugin
module.exports = {"stepindicator":"StepIndicator__stepindicator","items2":"StepIndicator__items2","items3":"StepIndicator__items3","items4":"StepIndicator__items4","items5":"StepIndicator__items5","items6":"StepIndicator__items6","items7":"StepIndicator__items7","items8":"StepIndicator__items8","done":"StepIndicator__done","leftAligned":"StepIndicator__leftAligned","rightAligned":"StepIndicator__rightAligned","hidden-spoken":"StepIndicator__hidden-spoken","hiddenSpoken":"StepIndicator__hidden-spoken"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/StepIndicator/StepIndicator.css
// module id = 534
// module chunks = 8